export default __webpack_public_path__ + "static/media/4.838e0aac.jpg";